export const getDefault = ({ title = null, activeColor = '#92D200' } = {}) => {
  const schema = ({
    name: 'Article',
    hasSubTitle: false,
    hasLine: false,
    hasSEO: false,
    activeColor,
    data: {
      content: ''
    }
  })
  if (typeof title === 'string' && title !== '') schema.data.title = title
  return schema
}
